import _ from "lodash";
import React from "react";
import IncrementQuantityPicker from "../shared/IncrementQuantityPicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { resolveStaticDefaultQuantity as resolveStaticDefaultQuantityValue } from "../../utils/quantityDefault";
import ProductVariantPickerService from "../../packs/services/convertflow/elements/product_variant_picker_service";

const Product = (props) => {
  const website = props.website;
  const element = props.element;
  const product = props.product;
  const variantOptions = props.variant?.options || {};
  const subscriptionRadioColor =
    element.options["products-subscription-radio-color"] ||
    variantOptions["products-subscription-radio-color"] ||
    variantOptions["products-hero-subscription-radio-color"] ||
    "#D4DDEA";
  const subscriptionSelectedRadioColor =
    element.options["products-subscription-radio-selected-color"] ||
    variantOptions["products-subscription-radio-selected-color"] ||
    variantOptions["products-hero-subscription-radio-selected-color"] ||
    "#003FFF";
  const subscriptionRadioWrapperStyle = {
    "--cf-products-subscription-radio-color": subscriptionRadioColor,
    "--cf-products-subscription-radio-selected-color": subscriptionSelectedRadioColor,
  };

  const productUsingShopifySource = ["Shopify", "ShopifyGraphql"].includes(
    element.options["products-source"]
  );

  const imagePlaceholderClass = ["ShopifyGraphql"].includes(element.options["products-source"])
    ? "cf-shopify-product-placeholder-svg"
    : "cf-generic-product-placeholder-svg"

  let productTitleText;
  let selectedProductVariant = product.variants && product.variants[0];

  if (product?.source?.toLowerCase() == "convertflow" && product?.title && selectedProductVariant) {
    productTitleText = `${selectedProductVariant?.title?.includes('Default Title') ? product?.title : selectedProductVariant.title}`
  } else if (product?.title && selectedProductVariant && element.options["products-title-show-variant-name"] !== "false") {
    productTitleText = `${product?.title} ${selectedProductVariant.title.includes('Default Title') ? '' : ' - ' + selectedProductVariant.title}`
  } else if (product?.title) {
    productTitleText = product?.title;
  } else {
    productTitleText = `Product ${product?.id}`;
  }

  let showBadgeCurrencyCode = false;

  let productDiscount;
  if (
    element.options["products-discount-type"] == "amount" &&
    element.options["products-discount-amount"]
  ) {
    showBadgeCurrencyCode = true;
    productDiscount = element.options["products-discount-amount"];
  } else if (
    element.options["products-discount-type"] == "percentage" &&
    element.options["products-discount-percentage"]
  ) {
    productDiscount = `${element.options["products-discount-percentage"]}%`;
  } else {
    productDiscount = "10%";
  }

  let showImageBadge = element.options["products-show-image-badge"] == "true" ||
    element.options["products-show-image-sold-out-badge"] == "true" && product.available === false;

  let productImageBadgeText;
  if (element.options["products-show-image-sold-out-badge"] == "true" && product.available === false) {
    productImageBadgeText = element.options["products-image-sold-out-badge-text"] || "SOLD OUT";
  } else if (element.options["products-image-badge-style"] == "custom") {
    productImageBadgeText = element.options["products-image-badge-custom-message"] || "10% OFF"
  } else if (element.options["products-discount-type"] == "detect") {
    if (selectedProductVariant?.compare_at_price) {
      showBadgeCurrencyCode = true;
      productImageBadgeText = `${((selectedProductVariant?.compare_at_price / 100) - selectedProductVariant?.price).toFixed(2)} OFF`
    } else if (props.builder == true && element.options["products-source"] == "Shopify") {
      productImageBadgeText = '10% OFF';
    } else if (props.builder == true) {
      showImageBadge = false;
    }
  } else {
    productImageBadgeText = productDiscount + " OFF";
  }

  const productImage = (
    <div className="cf-product-item-image-block cf-product-content-type" key={`product-image-${product.id}`}>
      <div className="cf-products-item-image-wrapper">
        {showImageBadge && (
          <div className="cf-products-item-badge" data-font={element.options["products-image-badge-font-family"]}>
            {showBadgeCurrencyCode && <span className="cf-products-currency-code">{website.currency_character}</span>}
            {productImageBadgeText}
          </div>
        )}

        <div className="cf-row cf-outer-center cf-products-item-image">
          {product.image && <img loading="lazy" src={product.image} />}
          {!product.image &&
            !["Shopify", "ShopifyGraphql"].includes(
              element.options["products-source"]
            ) && (
              <svg
                className="cf-products-placeholder-svg cf-outer-center"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 525.5 525.5"
              >
                <path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"></path>
                <path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z"></path>
                <path d="M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z"></path>
              </svg>
            )}
          {!product.image &&
            ["Shopify", "ShopifyGraphql"].includes(
              element.options["products-source"]
            ) && (
              <svg
                className="cf-products-placeholder-svg cf-outer-center product__main-image"
                viewBox="0 0 2192 2500"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="clip0_2_2">
                  <path
                    d="M1344.77 989.806C1344.24 986.017 1340.92 983.92 1338.18 983.689C1335.44 983.46 1277.48 979.165 1277.48 979.165C1277.48 979.165 1237.23 939.206 1232.81 934.783C1228.39 930.363 1219.76 931.708 1216.41 932.694C1215.92 932.839 1207.61 935.401 1193.88 939.65C1180.44 900.961 1156.71 865.407 1114.96 865.407C1113.81 865.407 1112.62 865.454 1111.43 865.521C1099.56 849.821 1084.85 843 1072.15 843C974.898 843 928.437 964.562 913.869 1026.34C876.08 1038.04 849.235 1046.37 845.806 1047.45C824.712 1054.06 824.045 1054.73 821.276 1074.6C819.191 1089.65 764 1516.43 764 1516.43L1194.06 1597L1427.08 1546.59C1427.08 1546.59 1345.28 993.596 1344.77 989.806H1344.77ZM1170.11 947.001L1133.72 958.263C1133.74 955.698 1133.75 953.175 1133.75 950.416C1133.75 926.371 1130.41 907.011 1125.06 891.664C1146.57 894.363 1160.89 918.836 1170.11 947.001ZM1098.37 896.432C1104.35 911.416 1108.24 932.92 1108.24 961.938C1108.24 963.423 1108.23 964.78 1108.21 966.153C1084.55 973.483 1058.83 981.441 1033.06 989.425C1047.53 933.579 1074.66 906.606 1098.37 896.432V896.432ZM1069.48 869.083C1073.68 869.083 1077.9 870.508 1081.95 873.293C1050.78 887.957 1017.38 924.892 1003.27 998.649L943.861 1017.05C960.385 960.788 999.623 869.083 1069.48 869.083H1069.48Z"
                    fill="#8F8F8F"
                  />
                  <path
                    d="M1338.28 983.843C1335.54 983.615 1277.65 979.32 1277.65 979.32C1277.65 979.32 1237.44 939.372 1233.03 934.95C1231.37 933.305 1229.15 932.462 1226.82 932.098L1194.34 1597L1427.08 1546.61C1427.08 1546.61 1345.37 993.748 1344.86 989.96C1344.33 986.171 1341.02 984.074 1338.28 983.843"
                    fill="#555555"
                  />
                  <path
                    d="M1115.54 1112.46L1086.76 1197.91C1086.76 1197.91 1061.54 1184.48 1030.62 1184.48C985.295 1184.48 983.014 1212.87 983.014 1220.02C983.014 1259.05 1084.96 1274 1084.96 1365.42C1084.96 1437.34 1039.25 1483.66 977.613 1483.66C903.65 1483.66 865.826 1437.72 865.826 1437.72L885.63 1372.42C885.63 1372.42 924.51 1405.73 957.317 1405.73C978.754 1405.73 987.474 1388.89 987.474 1376.58C987.474 1325.67 903.838 1323.4 903.838 1239.75C903.838 1169.34 954.477 1101.2 1056.7 1101.2C1096.09 1101.2 1115.54 1112.46 1115.54 1112.46"
                    fill="white"
                  />
                  <path
                    d="M811.975 1848V1775.27H840.669C846.185 1775.27 850.884 1776.33 854.767 1778.43C858.649 1780.52 861.608 1783.42 863.644 1787.13C865.704 1790.83 866.734 1795.09 866.734 1799.92C866.734 1804.75 865.692 1809.01 863.609 1812.7C861.526 1816.39 858.507 1819.27 854.553 1821.33C850.624 1823.39 845.865 1824.42 840.278 1824.42H821.99V1812.1H837.792C840.751 1812.1 843.19 1811.59 845.107 1810.57C847.049 1809.53 848.493 1808.1 849.44 1806.27C850.41 1804.43 850.896 1802.31 850.896 1799.92C850.896 1797.5 850.41 1795.4 849.44 1793.6C848.493 1791.77 847.049 1790.37 845.107 1789.37C843.166 1788.35 840.704 1787.84 837.721 1787.84H827.352V1848H811.975ZM891.565 1775.27V1848H876.437V1775.27H891.565ZM919.237 1849.03C915.757 1849.03 912.656 1848.43 909.933 1847.22C907.211 1845.99 905.057 1844.18 903.47 1841.79C901.908 1839.37 901.127 1836.36 901.127 1832.77C901.127 1829.74 901.683 1827.19 902.796 1825.13C903.908 1823.07 905.423 1821.41 907.341 1820.16C909.259 1818.9 911.437 1817.96 913.875 1817.32C916.337 1816.68 918.918 1816.23 921.617 1815.97C924.789 1815.64 927.346 1815.33 929.287 1815.05C931.228 1814.74 932.637 1814.29 933.513 1813.7C934.389 1813.1 934.827 1812.23 934.827 1811.07V1810.86C934.827 1808.61 934.117 1806.87 932.696 1805.63C931.299 1804.4 929.311 1803.79 926.73 1803.79C924.008 1803.79 921.842 1804.39 920.232 1805.6C918.622 1806.78 917.557 1808.27 917.036 1810.07L903.044 1808.94C903.754 1805.62 905.151 1802.76 907.235 1800.34C909.318 1797.91 912.005 1796.04 915.296 1794.73C918.61 1793.41 922.445 1792.74 926.801 1792.74C929.832 1792.74 932.732 1793.1 935.502 1793.81C938.295 1794.52 940.769 1795.62 942.923 1797.11C945.102 1798.6 946.818 1800.52 948.073 1802.87C949.327 1805.19 949.955 1807.97 949.955 1811.21V1848H935.608V1840.44H935.182C934.306 1842.14 933.134 1843.64 931.666 1844.95C930.199 1846.22 928.435 1847.23 926.375 1847.96C924.316 1848.67 921.936 1849.03 919.237 1849.03ZM923.57 1838.59C925.795 1838.59 927.76 1838.15 929.465 1837.28C931.169 1836.38 932.507 1835.17 933.477 1833.65C934.448 1832.14 934.933 1830.42 934.933 1828.5V1822.72C934.46 1823.02 933.809 1823.31 932.98 1823.57C932.175 1823.8 931.264 1824.03 930.246 1824.24C929.228 1824.43 928.21 1824.61 927.192 1824.78C926.174 1824.92 925.251 1825.05 924.422 1825.17C922.646 1825.43 921.096 1825.84 919.77 1826.41C918.444 1826.98 917.414 1827.75 916.681 1828.72C915.947 1829.66 915.58 1830.85 915.58 1832.27C915.58 1834.33 916.325 1835.9 917.817 1836.99C919.332 1838.06 921.25 1838.59 923.57 1838.59ZM986.336 1849.07C980.749 1849.07 975.943 1847.88 971.919 1845.51C967.918 1843.12 964.84 1839.81 962.686 1835.57C960.555 1831.33 959.49 1826.46 959.49 1820.94C959.49 1815.35 960.567 1810.45 962.721 1806.24C964.899 1802 967.989 1798.7 971.99 1796.33C975.99 1793.94 980.749 1792.74 986.265 1792.74C991.024 1792.74 995.19 1793.61 998.765 1795.34C1002.34 1797.06 1005.17 1799.49 1007.25 1802.62C1009.34 1805.74 1010.48 1809.41 1010.7 1813.62H996.421C996.019 1810.9 994.954 1808.71 993.225 1807.06C991.521 1805.37 989.284 1804.53 986.514 1804.53C984.17 1804.53 982.122 1805.17 980.37 1806.45C978.642 1807.71 977.293 1809.54 976.322 1811.96C975.351 1814.37 974.866 1817.29 974.866 1820.73C974.866 1824.21 975.339 1827.17 976.286 1829.61C977.257 1832.04 978.618 1833.9 980.37 1835.18C982.122 1836.46 984.17 1837.1 986.514 1837.1C988.242 1837.1 989.793 1836.74 991.166 1836.03C992.562 1835.32 993.711 1834.29 994.61 1832.94C995.534 1831.57 996.137 1829.92 996.421 1828.01H1010.7C1010.46 1832.17 1009.32 1835.84 1007.29 1839.02C1005.28 1842.16 1002.49 1844.63 998.943 1846.4C995.392 1848.18 991.189 1849.07 986.336 1849.07ZM1045.24 1849.07C1039.63 1849.07 1034.8 1847.93 1030.75 1845.66C1026.73 1843.36 1023.63 1840.12 1021.45 1835.93C1019.27 1831.71 1018.18 1826.73 1018.18 1820.98C1018.18 1815.37 1019.27 1810.44 1021.45 1806.2C1023.63 1801.97 1026.69 1798.66 1030.65 1796.3C1034.62 1793.93 1039.29 1792.74 1044.64 1792.74C1048.24 1792.74 1051.59 1793.32 1054.69 1794.48C1057.81 1795.62 1060.53 1797.34 1062.85 1799.63C1065.2 1801.93 1067.02 1804.82 1068.32 1808.3C1069.63 1811.75 1070.28 1815.8 1070.28 1820.44V1824.6H1024.22V1815.22H1056.04C1056.04 1813.04 1055.56 1811.12 1054.62 1809.43C1053.67 1807.75 1052.35 1806.44 1050.67 1805.49C1049.02 1804.52 1047.09 1804.04 1044.89 1804.04C1042.59 1804.04 1040.55 1804.57 1038.78 1805.63C1037.03 1806.68 1035.65 1808.09 1034.66 1809.86C1033.66 1811.61 1033.15 1813.57 1033.13 1815.72V1824.63C1033.13 1827.33 1033.63 1829.66 1034.62 1831.63C1035.64 1833.59 1037.07 1835.11 1038.92 1836.17C1040.77 1837.24 1042.96 1837.77 1045.49 1837.77C1047.17 1837.77 1048.71 1837.54 1050.11 1837.06C1051.5 1836.59 1052.7 1835.88 1053.69 1834.93C1054.69 1833.98 1055.44 1832.82 1055.97 1831.45L1069.96 1832.38C1069.25 1835.74 1067.79 1838.67 1065.59 1841.18C1063.41 1843.67 1060.59 1845.61 1057.14 1847.01C1053.7 1848.38 1049.74 1849.07 1045.24 1849.07ZM1095.28 1816.47V1848H1080.15V1775.27H1094.85V1803.08H1095.49C1096.72 1799.86 1098.71 1797.34 1101.46 1795.51C1104.2 1793.67 1107.65 1792.74 1111.79 1792.74C1115.58 1792.74 1118.88 1793.57 1121.7 1795.23C1124.54 1796.86 1126.74 1799.22 1128.3 1802.3C1129.89 1805.35 1130.67 1809.01 1130.65 1813.27V1848H1115.52V1815.97C1115.54 1812.61 1114.69 1809.99 1112.96 1808.12C1111.26 1806.25 1108.87 1805.32 1105.79 1805.32C1103.73 1805.32 1101.9 1805.75 1100.32 1806.63C1098.76 1807.51 1097.53 1808.78 1096.63 1810.46C1095.75 1812.12 1095.3 1814.12 1095.28 1816.47ZM1167.2 1849.07C1161.68 1849.07 1156.91 1847.89 1152.88 1845.55C1148.88 1843.18 1145.79 1839.89 1143.62 1835.68C1141.44 1831.44 1140.35 1826.53 1140.35 1820.94C1140.35 1815.31 1141.44 1810.38 1143.62 1806.17C1145.79 1801.93 1148.88 1798.64 1152.88 1796.3C1156.91 1793.93 1161.68 1792.74 1167.2 1792.74C1172.71 1792.74 1177.47 1793.93 1181.47 1796.3C1185.5 1798.64 1188.6 1801.93 1190.78 1806.17C1192.95 1810.38 1194.04 1815.31 1194.04 1820.94C1194.04 1826.53 1192.95 1831.44 1190.78 1835.68C1188.6 1839.89 1185.5 1843.18 1181.47 1845.55C1177.47 1847.89 1172.71 1849.07 1167.2 1849.07ZM1167.27 1837.35C1169.78 1837.35 1171.87 1836.64 1173.55 1835.22C1175.23 1833.77 1176.5 1831.81 1177.35 1829.32C1178.23 1826.84 1178.67 1824.01 1178.67 1820.83C1178.67 1817.66 1178.23 1814.83 1177.35 1812.35C1176.5 1809.86 1175.23 1807.9 1173.55 1806.45C1171.87 1805.01 1169.78 1804.29 1167.27 1804.29C1164.73 1804.29 1162.6 1805.01 1160.87 1806.45C1159.17 1807.9 1157.88 1809.86 1157 1812.35C1156.15 1814.83 1155.73 1817.66 1155.73 1820.83C1155.73 1824.01 1156.15 1826.84 1157 1829.32C1157.88 1831.81 1159.17 1833.77 1160.87 1835.22C1162.6 1836.64 1164.73 1837.35 1167.27 1837.35ZM1219.01 1775.27V1848H1203.88V1775.27H1219.01ZM1251.22 1848.89C1247.08 1848.89 1243.33 1847.82 1239.97 1845.69C1236.63 1843.54 1233.98 1840.38 1232.01 1836.21C1230.07 1832.02 1229.1 1826.88 1229.1 1820.8C1229.1 1814.55 1230.11 1809.35 1232.12 1805.21C1234.13 1801.04 1236.81 1797.93 1240.14 1795.87C1243.51 1793.79 1247.19 1792.74 1251.19 1792.74C1254.24 1792.74 1256.79 1793.27 1258.82 1794.31C1260.88 1795.32 1262.54 1796.6 1263.8 1798.14C1265.07 1799.66 1266.04 1801.15 1266.71 1802.62H1267.17V1775.27H1282.26V1848H1267.35V1839.26H1266.71C1266 1840.78 1264.99 1842.28 1263.69 1843.77C1262.41 1845.24 1260.74 1846.46 1258.68 1847.43C1256.65 1848.4 1254.16 1848.89 1251.22 1848.89ZM1256.02 1836.85C1258.46 1836.85 1260.52 1836.19 1262.2 1834.86C1263.9 1833.51 1265.2 1831.63 1266.1 1829.21C1267.03 1826.8 1267.49 1823.97 1267.49 1820.73C1267.49 1817.48 1267.04 1814.67 1266.14 1812.28C1265.24 1809.88 1263.94 1808.04 1262.23 1806.74C1260.53 1805.43 1258.46 1804.78 1256.02 1804.78C1253.53 1804.78 1251.44 1805.46 1249.73 1806.81C1248.03 1808.16 1246.74 1810.03 1245.86 1812.42C1244.99 1814.81 1244.55 1817.58 1244.55 1820.73C1244.55 1823.9 1244.99 1826.71 1245.86 1829.14C1246.76 1831.56 1248.05 1833.45 1249.73 1834.83C1251.44 1836.17 1253.53 1836.85 1256.02 1836.85ZM1319.56 1849.07C1313.95 1849.07 1309.12 1847.93 1305.07 1845.66C1301.04 1843.36 1297.94 1840.12 1295.76 1835.93C1293.59 1831.71 1292.5 1826.73 1292.5 1820.98C1292.5 1815.37 1293.59 1810.44 1295.76 1806.2C1297.94 1801.97 1301.01 1798.66 1304.96 1796.3C1308.94 1793.93 1313.6 1792.74 1318.95 1792.74C1322.55 1792.74 1325.9 1793.32 1329 1794.48C1332.13 1795.62 1334.85 1797.34 1337.17 1799.63C1339.51 1801.93 1341.34 1804.82 1342.64 1808.3C1343.94 1811.75 1344.59 1815.8 1344.59 1820.44V1824.6H1298.53V1815.22H1330.35C1330.35 1813.04 1329.88 1811.12 1328.93 1809.43C1327.99 1807.75 1326.67 1806.44 1324.99 1805.49C1323.33 1804.52 1321.4 1804.04 1319.2 1804.04C1316.91 1804.04 1314.87 1804.57 1313.09 1805.63C1311.34 1806.68 1309.97 1808.09 1308.97 1809.86C1307.98 1811.61 1307.47 1813.57 1307.45 1815.72V1824.63C1307.45 1827.33 1307.94 1829.66 1308.94 1831.63C1309.96 1833.59 1311.39 1835.11 1313.24 1836.17C1315.08 1837.24 1317.27 1837.77 1319.81 1837.77C1321.49 1837.77 1323.03 1837.54 1324.42 1837.06C1325.82 1836.59 1327.01 1835.88 1328.01 1834.93C1329 1833.98 1329.76 1832.82 1330.28 1831.45L1344.27 1832.38C1343.56 1835.74 1342.11 1838.67 1339.91 1841.18C1337.73 1843.67 1334.91 1845.61 1331.45 1847.01C1328.02 1848.38 1324.06 1849.07 1319.56 1849.07ZM1354.46 1848V1793.45H1369.13V1802.97H1369.7C1370.69 1799.59 1372.36 1797.03 1374.71 1795.3C1377.05 1793.55 1379.75 1792.67 1382.8 1792.67C1383.56 1792.67 1384.38 1792.72 1385.25 1792.82C1386.13 1792.91 1386.9 1793.04 1387.56 1793.21V1806.63C1386.85 1806.42 1385.87 1806.23 1384.61 1806.06C1383.36 1805.9 1382.21 1805.81 1381.17 1805.81C1378.94 1805.81 1376.96 1806.3 1375.2 1807.27C1373.48 1808.22 1372.1 1809.54 1371.08 1811.25C1370.09 1812.95 1369.59 1814.92 1369.59 1817.14V1848H1354.46Z"
                    fill="white"
                  />
                  <line
                    x1="1526.23"
                    y1="856.232"
                    x2="1922.23"
                    y2="460.232"
                    stroke="white"
                    strokeWidth="5"
                  />
                  <line
                    y1="-2.5"
                    x2="560.029"
                    y2="-2.5"
                    transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 664 858)"
                    stroke="white"
                    strokeWidth="5"
                  />
                  <line
                    y1="-2.5"
                    x2="560.029"
                    y2="-2.5"
                    transform="matrix(0.707107 0.707107 0.707107 -0.707107 1528 1642)"
                    stroke="white"
                    strokeWidth="5"
                  />
                  <line
                    x1="665.768"
                    y1="1643.77"
                    x2="269.768"
                    y2="2039.77"
                    stroke="white"
                    strokeWidth="5"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2_2">
                    <rect width="2192" height="2500" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            )}
        </div>
      </div>

      {element.options["products-images-to-show"] == "carousel" &&
        element.options["products-source"] == "ShopifyGraphql" && (
          <div className="cf-product__slider-wrap">
            <div className="cf-product__slider">
              {product?.imageList?.length > 0 && (
                Object.values(product.imageList).map((image, index) => {
                  return (
                    <img
                      key={`product-image-${product.id}-${image.id}`}
                      className={`cf-product__image cf-product__image--${
                        index == 0 ? "active" : ""
                      }`}
                      src={image.transformedSrc}
                    />
                  );
                })
              )}

              {product?.imageList?.length == 0 && props.builder == true && (
                <React.Fragment>
                  <img key={`product-image-${product.id}-0`} className={`cf-product__image cf-product__image--active ${imagePlaceholderClass}`} style={{ backgroundColor: 'rgba(105, 114, 123, 0.5)' }} />
                  <img key={`product-image-${product.id}-1`} className={`cf-product__image ${imagePlaceholderClass}`} style={{ backgroundColor: 'rgba(105, 114, 123, 0.5)' }} />
                  <img key={`product-image-${product.id}-2`} className={`cf-product__image ${imagePlaceholderClass}`} style={{ backgroundColor: 'rgba(105, 114, 123, 0.5)' }} />
                </React.Fragment>
              )}
            </div>
          </div>
        )}
    </div>
  );

  const productTitle = (
    <div
      key={`product-title-${product.id}`}
      className={`cf-row cf-outer-center cf-products-item-title cf-merge-tag-allowed cf-product-content-type ${
        props.layout == "list" ? "cf-left" : ""
      }`}
      data-font={element.options["products-item-title-font"]}
    >
      <p dangerouslySetInnerHTML={{ __html: productTitleText }} />
    </div>
  );

  function addZeroes(num) {
    const dec = (num + "").split(".")[1];
    const len = dec && dec.length > 2 ? dec.length : 2;
    return Number(num).toFixed(len);
  }

  const productAdapter = selectedProductVariant || product;

  let priceFormatted = "0.00";
  if (productAdapter.price) {
    priceFormatted = addZeroes(productAdapter.price);
    if ((priceFormatted + "").split(".")[1] == "00") {
      priceFormatted = Math.trunc(priceFormatted);
    }
  }

  let discountedPriceFormatted;

  if (element.options["products-discount-type"] == "amount") {
    const discountAmount = element.options["products-discount-amount"] || 10;

    discountedPriceFormatted = (productAdapter.price - discountAmount).toFixed(2);
  }

  if (element.options["products-discount-type"] == "percentage") {
    const discountAmount =
      element.options["products-discount-percentage"] || 10;

    discountedPriceFormatted = (
      productAdapter.price -
      productAdapter.price * (parseInt(discountAmount) * 0.01)
    ).toFixed(2);
  }

  if (element.options["products-discount-type"] == "detect") {
    if (productAdapter.compare_at_price) {
      discountedPriceFormatted = productAdapter.price;
      priceFormatted = productAdapter.compare_at_price / 100;
    }
  }

  if (discountedPriceFormatted && discountedPriceFormatted <= 0) {
    discountedPriceFormatted = "0.00";
  }

  if (discountedPriceFormatted) {
    discountedPriceFormatted = addZeroes(discountedPriceFormatted);

    if ((discountedPriceFormatted + "").split(".")[1] == "00") {
      discountedPriceFormatted = Math.trunc(discountedPriceFormatted);
    }

    if (discountedPriceFormatted == 0) {
      discountedPriceFormatted = "0";
    }
  }

  const productPrice = (
    <div
      key={`product-price-${product.id}`}
      data-font={element.options["products-item-price-font"]}
      className={`cf-row cf-outer-center cf-products-item-price cf-product-content-type ${
        props.layout == "list" ? "cf-left" : ""
      }`}
      data-discount={discountedPriceFormatted ? true : undefined}
    >
      <p>
        {!discountedPriceFormatted && (
          <React.Fragment>
            {" "}
            <span className="cf-products-currency-code">{website.currency_character}</span>
            <span className="cf-products-item-price-base">
              {parseFloat(priceFormatted).toFixed(2)}
            </span>
          </React.Fragment>
        )}
        {discountedPriceFormatted && (
          <React.Fragment>
            <strike>
              <span className="cf-products-currency-code">{website.currency_character}</span>
              <span className="cf-products-item-price-base">
                {parseFloat(priceFormatted).toFixed(2)}
              </span>
            </strike>{" "}
            <span className="cf-products-currency-code">{website.currency_character}</span>
            <span className="cf-products-item-price-discount">
              {parseFloat(discountedPriceFormatted).toFixed(2)}
            </span>
          </React.Fragment>
        )}
      </p>
    </div>
  );

  let productDescriptionContent = product.description
    ? product.description
    : `<p>Example Description For ${productTitleText}</p>`;

  if (props.builder == true && element.options["products-description-formatting"] == "cf-unformatted-text") {
    let tempDiv = document.createElement("div");
    tempDiv.innerHTML = productDescriptionContent;
    productDescriptionContent = tempDiv.textContent || tempDiv.innerText || "";
  }

  const productDescription = (
    <div
      key={`product-description-${product.id}`}
      className={`cf-row cf-outer-center cf-products-item-description cf-product-content-type ${
        props.layout == "list" ? "cf-left" : ""
      }`}
      data-font={element.options["products-item-description-font"]}
      dangerouslySetInnerHTML={{ __html: productDescriptionContent }}
    ></div>
  );

  let productButton;
  let productVariants;

  const canShowButton = element.options["button-show"]
    ? element.options["button-show"]
    : element.options["products-button"]
    ? element.options["products-button"]
    : "true"

  if (
    canShowButton !== "false" ||
    element.options["confirmation-type"] == "cart"
  ) {
    let buttonText = element.html
      ? element.html
      : element.options["confirmation-type"] == "cart" && element.options["products-source"]?.toLowerCase() !== "convertflow"
      ? "<p>Add To Cart</p>"
      : "<p>Go To Product</p>";

    let productVariantsRequired =
      canShowButton !== "false" &&
      (!["Shopify", "ShopifyGraphql"].includes(
        element.options["products-source"]
      ) ||
        (["Shopify", "ShopifyGraphql"].includes(
          element.options["products-source"]
        ) &&
          element.options["confirmation-type"] == "cart"));

    let productVariantsDropdown;

    if (
      product &&
      product.product_variants &&
      Object.values(product.product_variants).length > 0
    ) {
      productVariantsDropdown = product.product_variants.map(
        (productVariant) => {
          return (
            <option key={productVariant.id} value={productVariant.id}>{productVariant.title}</option>
          );
        }
      );
    }

    productVariants = (
      <div
        key={`product-variants-${product.id}`}
        className={`cf-form-2 cf-form-theme-default cf-field-regular cf-products-item-variants`}
        style={{ display: productVariantsRequired ? "block" : "none" }}
      >
        <select disabled={props.builder == true ? true : undefined}>
          <option value="">{product.title}</option>
          {productVariantsDropdown}
        </select>
      </div>
    );

    productButton = (
      <div
        key={`product-button-${product.id}`}
        className={`cf-row cf-outer-center cf-products-item-button-outer ${props.classes.buttonLayoutClasses}`}
        data-element-id={element.id}
      >
        <div
          className={`${props.classes.buttonClasses} cf-products-item-button`}
          dangerouslySetInnerHTML={{
            __html:
              props.builder == true
                ? "<div class='froala-editor'>" + buttonText + "</div>"
                : buttonText,
          }}
        ></div>
      </div>
    );
  }

  const variantPickerLabel = product.options ? product.options.map((f) => f.name == "Title" ? "Options" : f.name).join(" / ") : "Option";

  let productVariantPicker = (
    <div key={`product-variant-picker-${product.id}`} className="cf-variant-picker-wrapper cf-product-content-type" style={{ display: ProductVariantPickerService.shouldShow(element, element.options["products-source"]) ? 'block' : 'none' }}>
      {element.options["products-variant-picker-style"] == "cf-options-buttons" &&
        element.options["products-source"] == "ShopifyGraphql" ? (
          <React.Fragment>
            {product.options && product.options.map((option) => {
              let filteredOptions = option.values.filter(e => e !== 'Default Title')

              return (
                <React.Fragment key={option.id}>
                  {option.name !== "Title" && (
                    <p className="cf-variant-picker-label" style={{ fontSize: "13px" }}>
                      {option.name}
                    </p>
                  )}

                  {filteredOptions.length > 0 && (
                    <div className="cf-products-options-wrapper" data-font={element.options["products-variant-picker-font-family"]}>
                      {filteredOptions.map((value, i) => {
                        return <div key={`${value}-${i}`} className={`cf-products-option-item ${i == 0 ? 'cf-products-item-button--selected' : ''}`}>{value}</div>;
                      })}
                    </div>
                  )}

                </React.Fragment>
              );
            })}
          </React.Fragment>
        ) : (
          <div className="cf-form-2 cf-form-theme-default cf-field-regular cf-products-item-variants">
            <p className="cf-variant-picker-label" style={{ fontSize: "13px" }}>
              {variantPickerLabel}
            </p>

            <select disabled={props.builder == true ? true : undefined}>
              {product && product.variants && product.variants.length > 0 ? (
                <React.Fragment>
                  {product.variants.map((productVariant) => {
                    return (
                      <option key={`product-variant-${product.id}-${productVariant.id}`} value={productVariant.id} dangerouslySetInnerHTML={{ __html: productVariant.title == "Default Title" ? product.title : productVariant.title }} />
                    );
                  })}
                </React.Fragment>
              ) : (
                <option value="" dangerouslySetInnerHTML={{ __html: product.title }} />
              )}
            </select>
          </div>
        )}
    </div>
  );

  const renderStarIcon = (score) => {
    const fullStars = Math.floor(score);
    const hasHalfStar = score % 1 !== 0;

    const starIcons = [];

    for (let i = 0; i < fullStars; i++) {
      starIcons.push(<FontAwesomeIcon key={`product-reviews-stars-${product.id}-full-${i}`} icon="fa-star" />);
    }

    if (hasHalfStar) {
      starIcons.push(<FontAwesomeIcon key={`product-reviews-stars-${product.id}-half`} icon="fa-star-half-stroke" />);
    }

    const remainingStars = 5 - starIcons.length;
    for (let i = 0; i < remainingStars; i++) {
      starIcons.push(<FontAwesomeIcon key={`product-reviews-stars-${product.id}-empty-${i}`} icon="fa-regular fa-star" color="white" />);
    }

    return starIcons;
  };

  const IntegrationReviews = props.productReviews;

  let productReviews = (
    <div key={`product-reviews-${product.id}`} className="cf-products-reviews-wrapper cf-product-content-type">
      <div className="cf-products-reviews" data-font={element.options["products-reviews-font-family"]}>
        <div key={`product-reviews-stars-inner-${product.id}`} className="cf-products-reviews-stars-inner">
          {IntegrationReviews ? (
            renderStarIcon(IntegrationReviews.rating)
          ) :
            <React.Fragment key={`product-reviews-stars-${product.id}`}>
              <FontAwesomeIcon icon="fa-star" />
              <FontAwesomeIcon icon="fa-star" />
              <FontAwesomeIcon icon="fa-star" />
              <FontAwesomeIcon icon="fa-star" />
              <FontAwesomeIcon icon="fa-star" />
            </React.Fragment>
          }
        </div>

        <div className="cf-products-reviews-count"> {IntegrationReviews ? IntegrationReviews.product_total_reviews : ""}</div>

        { IntegrationReviews && IntegrationReviews.product_total_reviews > 0 &&
          <div className="cf-products-reviews-label">{element.options["products-reviews-label"] ? element.options["products-reviews-label"] : "Reviews" }</div>}
      </div>
    </div>
  )

  const resolveStaticDefaultQuantity = () => {
    return resolveStaticDefaultQuantityValue(element.options);
  };

  const isCartSource = element.options["shopify-products-source"] == "cart" || !element.options["shopify-products-source"];
  const showQuantityPicker = element.options["confirmation-type"] == "cart" || isCartSource;

  const productQuantityPicker = (
    ["ShopifyGraphql", "Shopify"].includes(element.options["products-source"]) &&
      <div className="cf-product-content-type" key={`product-quantity-picker-${product.id}`} style={{ display: showQuantityPicker ? 'block' : 'none'}}>
        <IncrementQuantityPicker label={element.options["products-quantity-label-text"]} value={resolveStaticDefaultQuantity()}/>
      </div>
  )

  const isSubscriptionCardType = element.options["products-subscription-choices-type"] == "card";
  const parseNumericAmount = (value) => {
    if (value === null || value === undefined || value === "") return null;
    const parsed = parseFloat(String(value).replace(/[^0-9.-]/g, ""));
    return Number.isFinite(parsed) ? parsed : null;
  };

  const selectedVariantForPricing = product?.is_variant ? product : (product?.variants?.[0] || null);
  const selectedVariantSubscriptions = selectedVariantForPricing?.subscriptions || [];
  const settingsSourceSubscriptions = product?.subscriptions?.length ? product.subscriptions : selectedVariantSubscriptions;
  const stablePlanIndexById = {};
  let stablePlanCounter = 0;
  settingsSourceSubscriptions.forEach((group) => {
    Object.values(group.sellingPlans || {}).forEach((plan) => {
      if (stablePlanIndexById[plan.id] === undefined) {
        stablePlanIndexById[plan.id] = stablePlanCounter;
        stablePlanCounter++;
      }
    });
  });
  const selectedVariantCompareAtPrice = selectedVariantForPricing?.compare_at_price
    ? parseNumericAmount(selectedVariantForPricing.compare_at_price / 100)
    : null;

  const formatAmount = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Math.max(0, amount));
  };

  const getCurrencySymbol = (currencyCode) => {
    if (!currencyCode) return website?.currency_character || "";

    try {
      const parts = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: currencyCode,
        currencyDisplay: "symbol",
      }).formatToParts(1);
      return parts.find((part) => part.type === "currency")?.value || website?.currency_character || "";
    } catch (error) {
      return website?.currency_character || "";
    }
  };

  const shouldShowPlanPrice = (planIndex) => {
    const planToggle = element.options[`products-subscription-show-price-${planIndex}`];
    if (planToggle === "true") return true;
    if (planToggle === "false") return false;
    return element.options["products-subscription-show-price"] === "true";
  };

  const getSubscriptionPricing = (subscription) => {
    if (!subscription) return null;

    const directPrice = parseNumericAmount(subscription.price);
    if (directPrice !== null) {
      return {
        price: subscription.price,
        priceCurrency: subscription.priceCurrency || selectedVariantForPricing?.price_currency || product?.price_currency,
        compareAtPrice: subscription.compareAtPrice
      };
    }

    const selectedVariantSubscriptions = selectedVariantForPricing?.subscriptions || [];
    for (const group of selectedVariantSubscriptions) {
      const plans = Array.isArray(group.sellingPlans) ? group.sellingPlans : Object.values(group.sellingPlans || {});
      for (const plan of plans) {
        if (plan?.id == subscription.id) {
          return {
            price: plan.price,
            priceCurrency: plan.priceCurrency || selectedVariantForPricing?.price_currency || product?.price_currency,
            compareAtPrice: plan.compareAtPrice
          };
        }
      }
    }

    return null;
  };

  const renderPlanPriceColumn = (planIndex, planPrice, priceCurrency, sellingPlanCompareAtPrice = null) => {
    if (isSubscriptionCardType !== true || !shouldShowPlanPrice(planIndex)) {
      return null;
    }

    const parsedPlanPrice = parseNumericAmount(planPrice);
    if (parsedPlanPrice === null) return null;

    const rawPlanPriceType = element.options["products-subscription-price-type"] || "";
    const planPriceType = rawPlanPriceType === "none" ? "" : rawPlanPriceType;
    const discountAmount = parseNumericAmount(
      element.options["products-subscription-discount-amount"]
    );
    const discountPercentage = parseNumericAmount(
      element.options["products-subscription-discount-percentage"]
    );
    const comparePriceSetting = element.options[`products-subscription-compare-price-${planIndex}`];
    const parsedComparePriceSetting = parseNumericAmount(comparePriceSetting);
    const parsedSellingPlanComparePrice = parseNumericAmount(sellingPlanCompareAtPrice);
    const priceDescription = element.options[`products-subscription-price-description-${planIndex}`];
    let currentPrice = parsedPlanPrice;
    let comparePrice = null;

    if (planPriceType === "amount" && discountAmount !== null) {
      comparePrice = parsedPlanPrice;
      currentPrice = Math.max(0, parsedPlanPrice - discountAmount);
    } else if (planPriceType === "percentage" && discountPercentage !== null) {
      comparePrice = parsedPlanPrice;
      currentPrice = Math.max(0, parsedPlanPrice - parsedPlanPrice * (discountPercentage * 0.01));
    } else if (planPriceType === "detect") {
      comparePrice = parsedComparePriceSetting ?? parsedSellingPlanComparePrice ?? selectedVariantCompareAtPrice;
    } else {
      comparePrice = parsedComparePriceSetting;
    }

    const currencySymbol = getCurrencySymbol(priceCurrency);

    return (
      <div
        className="cf-subscription-plan-price-column"
        style={{
          marginLeft: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          alignSelf: "flex-start",
          textAlign: "right",
          lineHeight: "1.2",
          gap: "2px",
        }}
      >
        {(comparePrice !== null || comparePriceSetting) && (
          <div
            className="cf-subscription-plan-compare-price"
            style={{ textDecoration: "line-through", opacity: "0.75", fontSize: "0.9em" }}
          >
            {comparePrice !== null ? `${currencySymbol}${formatAmount(comparePrice)}` : String(comparePriceSetting)}
          </div>
        )}

        <div className="cf-subscription-plan-price" style={{ whiteSpace: "nowrap" }}>
          <span className="cf-subscription-plan-price-currency">{currencySymbol}</span>
          <span className="cf-subscription-plan-price-value">{formatAmount(currentPrice)}</span>
        </div>

        {priceDescription && (
          <div className="cf-subscription-plan-price-description" style={{ fontSize: "0.85em", opacity: "0.85" }}>
            {priceDescription}
          </div>
        )}
      </div>
    );
  };

  let productSubscription = (
    element.options["products-source"] == "ShopifyGraphql" &&
      <div key={`product-subscription-${product.id}`} className="cf-products-subscription-dropdown-wrapper cf-product-content-type" style={{ display: element.options["confirmation-type"] == "cart" ? 'block' : 'none'}}>
        <div className="cf-form-2 cf-form-theme-default cf-field-regular">
          <p className="cf-products-subscription-label" style={{ fontSize: "13px" }}>
            {element.options["products-subscription-label-text"] ? element.options["products-subscription-label-text"] : "Frequency"}
          </p>

          {(!element.options["products-subscription-choices-type"] || element.options["products-subscription-choices-type"] == "dropdown" && product) && (
            <select className="cf-subscription-select" disabled={props.builder == true ? true : undefined}>
              {(product.requires_selling_plan !== true || selectedVariantSubscriptions.length == 0) && (<option value="">{element.options["products-subscription-default-plan-text"] ? element.options["products-subscription-default-plan-text"] : "One-time purchase"}</option>)}

              {selectedVariantSubscriptions.map((subscriptionGroup) => {
                return Object.values(subscriptionGroup.sellingPlans).map((subscription) => {
                  return (
                    <option key={`product-subscription-${product.id}-${subscription.id}`} value={subscription.id}>
                      {element.options["products-subscription-show-group-name"] !== "false" ? subscriptionGroup.name + " - " : ""} {subscription.name}
                    </option>
                  );
                })
              })}
            </select>
          )}

          {(element.options["products-subscription-choices-type"] == "radios" && product) && (
            <div className="cf-products-subscription-radio-wrapper" data-font={element.options["products-subscription-choices-font-family"]} style={subscriptionRadioWrapperStyle}>
              {(product.requires_selling_plan !== true || selectedVariantSubscriptions.length == 0) && (
                <p>
                  <input type="radio" id="one-time-purchase" name="cf-subscription-type" value="" />
                  <label htmlFor="one-time-purchase">
                    {element.options["products-subscription-default-plan-text"] ? element.options["products-subscription-default-plan-text"] : "One-time purchase"}
                  </label>
                </p>
              )}

              {selectedVariantSubscriptions.map((subscriptionGroup) => {
                return Object.values(subscriptionGroup.sellingPlans).map((subscription) => {
                  return (
                    <p key={`product-subscription-${product.id}-${subscription.id}`}>
                      <input type="radio" id={subscription.id} name="cf-subscription-type" value={subscription.id} />
                      <label htmlFor={subscription.id}>{element.options["products-subscription-show-group-name"] !== "false" ? subscriptionGroup.name + " - " : ""} {subscription.name}</label>
                    </p>
                  );
                })
              })}
            </div>
          )}

          {(element.options["products-subscription-choices-type"] == "card" && product) && (
            <div className="cf-products-subscription-radio-wrapper" data-font={element.options["products-subscription-choices-font-family"]} style={subscriptionRadioWrapperStyle}>
              {(product.requires_selling_plan !== true || selectedVariantSubscriptions.length == 0) &&
                element.options["products-subscription-hide-default"] !== "false" && (
                <div className="cf-subscription-radio-card">
                  {element.options["products-subscription-popular-badge-default"] == "true" && (
                    <div className="cf-subscription-popular-badge">
                      {element.options["products-subscription-badge-text-default"] || "MOST POPULAR"}
                    </div>
                  )}
                  <div className="cf-subscription-radio-card-inner">
                    <div className="cf-subscription-radio-row">
                      <input type="radio" id={`one-time-purchase-${product.id}`} name={`cf-subscription-type-${product.id}`} value="" />
                      <div className="cf-subscription-plan-details">
                        <label htmlFor={`one-time-purchase-${product.id}`}>
                          {element.options["products-subscription-default-plan-text"] ? element.options["products-subscription-default-plan-text"] : "One-time purchase"}
                        </label>
                        {element.options["products-subscription-description-default"] && (
                          <div className="cf-subscription-radio-description" dangerouslySetInnerHTML={{ __html: element.options["products-subscription-description-default"] }} />
                        )}
                      </div>
                      {renderPlanPriceColumn(
                        "default",
                        selectedVariantForPricing?.price,
                        selectedVariantForPricing?.price_currency
                      )}
                    </div>
                  </div>
                </div>
              )}

              {selectedVariantSubscriptions.length > 0 && (() => {
                let planCounter = 0;
                return selectedVariantSubscriptions.map((subscriptionGroup) =>
                  Object.values(subscriptionGroup.sellingPlans).map((subscription) => {
                    const currentIndex = planCounter++;
                    const settingsIndex = stablePlanIndexById[subscription.id] ?? currentIndex;
                    if (element.options[`products-subscription-hide-${settingsIndex}`] === "false") return null;

                    const showGroupName = element.options["products-subscription-show-group-name"] !== "false";
                    const labelText = `${showGroupName ? `${subscriptionGroup.name} - ` : ""}${subscription.name}`;
                    const resolvedPricing = getSubscriptionPricing(subscription);

                    return (
                      <div className="cf-subscription-radio-card" key={`product-subscription-card-${product.id}-${subscription.id}`}>
                        {element.options[`products-subscription-popular-badge-${settingsIndex}`] == "true" && (
                          <div className="cf-subscription-popular-badge">
                            {element.options[`products-subscription-badge-text-${settingsIndex}`] || "MOST POPULAR"}
                          </div>
                        )}
                        <div className="cf-subscription-radio-card-inner">
                          <div className="cf-subscription-radio-row">
                            <input type="radio" id={`${subscription.id}-${product.id}`} name={`cf-subscription-type-${product.id}`} value={subscription.id} />
                            <div className="cf-subscription-plan-details">
                              <label htmlFor={`${subscription.id}-${product.id}`}>{labelText}</label>
                              {element.options[`products-subscription-description-${settingsIndex}`] && (
                                <div className="cf-subscription-radio-description" dangerouslySetInnerHTML={{ __html: element.options[`products-subscription-description-${settingsIndex}`] }} />
                              )}
                            </div>
                            {renderPlanPriceColumn(
                              settingsIndex,
                              resolvedPricing?.price ?? subscription.price,
                              resolvedPricing?.priceCurrency ?? subscription.priceCurrency,
                              resolvedPricing?.compareAtPrice ?? subscription.compareAtPrice
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })
                );
              })()}
            </div>
          )}
        </div>
      </div>
  )

  const productRemoveFromCart = (
    element.options["products-source"] == "ShopifyGraphql" &&
    (!element.options["shopify-products-source"] || element.options["shopify-products-source"] == "cart") && (
      <div key={`product-remove-from-cart-${product.id}`} className="cf-products-item-remove-from-cart cf-product-content-type" data-font={element.options["products-remove-from-cart-font-family"]}>
        <p>{element.options["products-remove-from-cart-text"] ? element.options["products-remove-from-cart-text"] : "Remove"}</p>
      </div>
    )
  )

  const orderedProductContent = (exluded_content_types = []) => {
    const content_types = [
      "image",
      "reviews",
      "title",
      "price",
      "description",
      "quantity-picker",
      "variant-picker",
      "subscription",
      "remove-from-cart",
      "button",
    ];

    let sorted_content_types = content_types
      .map((type) => ({
        title: type.replace(/(-[a-z])/g, (x) => x.toUpperCase()[1]),
        show: element.options[`${type}-show`],
        position: element.options[`${type}-position`],
      })).sort((a, b) => {
        if (a.position === undefined) return 1;
        if (b.position === undefined) return -1;
        return a.position - b.position;
      });

    return (
      <React.Fragment>
        {sorted_content_types
          .filter((type) => {
            let consideredShowValue = type.show;

            // handle reviews
            if (type.title == "reviews") {
              if (element.options["reviews-show"] == undefined || element.options["products-source"] !== "ShopifyGraphql") {
                consideredShowValue = "false";
              }
            }

            // handle description legacy value
            if (type.title == "description" && element.options["description-show"] == undefined) {
              consideredShowValue =
                element.options["products-descriptions"] !== "false" &&
                (productUsingShopifySource || product.description)
                  ? "true"
                  : "false";
            }

            // handle subscription legacy value
            if (type.title == "subscription" && element.options["subscription-show"] == undefined) {
              consideredShowValue = "false";
            }

            // handle quantity picker legacy value
            if (type.title == "quantityPicker" && element.options["quantity-picker-show"] == undefined) {
              consideredShowValue = element.options["products-quantity"]
                ? element.options["products-quantity"]
                : "false";
            }

            // handle variant picker legacy value
            if (type.title == "variantPicker") {
              if (element.options["variant-picker-show"] == undefined || element.options["products-source"] == "Shopify") {
                consideredShowValue = "true";
              }
            }

            // handle button legacy value
            if (type.title == "button") {
              if(element.options["products-source"] == "Shopify" && element.options["confirmation-type"] == "cart") {
                consideredShowValue = "true";
              } else if (element.options["button-show"] == undefined) {
                consideredShowValue = element.options["products-button"]
                  ? element.options["products-button"]
                  : "true";
              }
            }

            // handle remove from cart
            if (type.title == "removeFromCart") {
              if (element.options["remove-from-cart-show"] == undefined) {
                consideredShowValue = "false";
              }
            }

            return (
              consideredShowValue !== "false" &&
              !exluded_content_types.includes(type.title)
            );
          })
          .map((content_type) => {
            return eval(
              "product" +
                content_type.title.charAt(0).toUpperCase() +
                content_type.title.slice(1)
            );
          })}
      </React.Fragment>
    );
  };

  let sourceClassName = "";
  if (element.options["products-source"] == "ShopifyGraphql") {
    sourceClassName = "cf-products-item--shopify-graphql";
  } else if (element.options["products-source"] == "Shopify") {
    sourceClassName = "cf-products-item--shopify";
  }

  let productMobileResponsive = element.options["products-layout-mobile-responsive"] !== "false";

  return (
    <React.Fragment>
      <div
        key={`product-${product.id}`}
        className={`cf-products-item ${
          props.layout == "list" ? "cf-row cf-outer-center" : ""
        } ${sourceClassName}`}
        data-product-id={product.id}
        style={{
          display:
            props.builder == true || props.preview == true ? "block" : "none",
        }}
      >
        <div key={`product-inner-${product.id}`} className="cf-products-item-inner">
          {props.layout == "grid" && (
            <React.Fragment>
              <div key={`product-info-${product.id}`} className="cf-row cf-outer-center cf-products-item-info">
                {orderedProductContent()}
              </div>
            </React.Fragment>
          )}

          {props.layout == "list" && (
            <React.Fragment>
              <div key={`product-list-${product.id}`} className="cf-row cf-outer-center cf-products-list">
                <div className="cf-products-item-inner-col cf-col-md-3" data-mobile-responsive={productMobileResponsive}>
                  {element.options["image-show"] !== "false" && productImage}
                </div>

                <div className={`cf-products-item-inner-col ${element.options["image-show"] !== "false" ? "cf-col-md-9" : "cf-col-md-12"} cf-products-item-info`} data-mobile-responsive={productMobileResponsive}>
                  {orderedProductContent(["image"])}
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Product;
